export const getStateAndTransportType = (advert, t) => {
  const transport = advert.transport && advert.transport.slug;
  if (!transport) return '';
  const transports = {
    avto: t('легковое авто'),
  };
  const state = advert.is_new ? t('новое') : t('с пробегом');
  return {
    transportType: transports[transport] || advert.transport.title,
    state,
  };
};



// WEBPACK FOOTER //
// ./src/shared/components/SuggestForDefaultAd/SuggestForm/utils.js